class ScrollingFeaturesBar {
  constructor(options = {}) {
    this.options = options;
    this.init();
  }

  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setup());
    } else {
      this.setup();
    }
    window.addEventListener("resize", () => this.adjustFeaturesTrack());
    if (document.fonts) {
      document.fonts.ready.then(() => this.setup());
    }
  }

  setup() {
    const allSections = document.querySelectorAll('[class*="section-"]');
    allSections.forEach((section) => {
      if (section.querySelector(".features-track")) {
        this.initSection(section);
      }
    });
  }

  initSection(section) {
    const trackContainer = section.querySelector(".features-track-container");
    const track = section.querySelector(".features-track");
    if (!trackContainer || !track) return;

    // On ne garde que 2 copies .feature-items pour le loop
    // Supprimer les copies en trop laissées par le Liquid (qui en génère 4)
    const allGroups = Array.from(track.querySelectorAll(".feature-items"));
    // Garder uniquement les 2 premières, supprimer le reste
    allGroups.forEach((g, i) => { if (i >= 2) g.remove(); });

    const featureItems = track.querySelector(".feature-items");
    if (!featureItems) return;

    this.configureScrollingAnimation(section, track);

    const images = Array.from(featureItems.querySelectorAll("img"));
    if (images.length === 0) {
      this.adjustFeaturesTrack(section, trackContainer, track, featureItems);
    } else {
      const promises = images.map((img) => {
        if (img.complete && img.naturalHeight !== 0) return Promise.resolve();
        return new Promise((resolve) => {
          img.addEventListener("load",  resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
      });
      Promise.all(promises).then(() => {
        this.adjustFeaturesTrack(section, trackContainer, track, featureItems);
      });
    }
  }

  configureScrollingAnimation(section, track) {
    const pauseOnHover = section.classList.contains("pause-on-hover");
    if (pauseOnHover) {
      track.addEventListener("mouseenter", () => { track.style.animationPlayState = "paused"; });
      track.addEventListener("mouseleave", () => { track.style.animationPlayState = "running"; });
    }
  }

  adjustFeaturesTrack(section, trackContainer, track, featureItems) {
    // Appelé sans arguments depuis resize
    if (!section) {
      document.querySelectorAll('[class*="section-"]').forEach((section) => {
        if (section.querySelector(".features-track")) {
          const trackContainer = section.querySelector(".features-track-container");
          const track          = section.querySelector(".features-track");
          const featureItems   = track.querySelector(".feature-items");
          if (trackContainer && track && featureItems) {
            this.adjustFeaturesTrack(section, trackContainer, track, featureItems);
          }
        }
      });
      return;
    }
    if (!trackContainer || !track || !featureItems) return;

    // La largeur du track = exactement 2x le premier groupe
    // → translateX(-50%) revient pile au début = zéro saut
    const groupWidth = featureItems.offsetWidth;
    if (groupWidth > 0) {
      track.style.width = `${groupWidth * 2}px`;
    }

    // Hauteur : on force la hauteur mesurée après chargement des images
    // car un script externe peut avoir posé un style="height:17px" parasite avant ce call
    const contentHeight = featureItems.offsetHeight;
    if (contentHeight > 0) {
      trackContainer.style.height = contentHeight + 'px';
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new ScrollingFeaturesBar();
});